// import React from "react";

// const CustomCheckbox = ({ checked, onChange }) => (
//   <div
//     onClick={(e) => { e.stopPropagation(); onChange(); }}
//     style={{
//       width: "16px",
//       height: "16px",
//       borderRadius: "3px",
//       border: "1.5px solid #aaa",
//       // backgroundColor: checked ? "#1976d2" : "#fff",
//       backgroundColor: checked ? "#fff" : "#fff",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: "pointer",
//       flexShrink: 0,
//     }}
//   >
//     {checked && (
//       <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
//         <path d="M1 3.5L3.8 6.5L9 1" stroke="#333" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//       </svg>
//     )}
//   </div>
// );

// const CoursePlanTable = ({ coursePlans = [], selectedPlanIds = [], setSelectedPlanIds }) => {
//   const allSelected =
//     coursePlans.length > 0 && coursePlans.every((p) => selectedPlanIds.includes(p.course_plan_id));

//   const handleHeaderCheck = () => {
//     if (allSelected) setSelectedPlanIds([]);
//     else setSelectedPlanIds(coursePlans.map((p) => p.course_plan_id));
//   };

//   const handleRowCheck = (id) => {
//     setSelectedPlanIds((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   const thStyle = {
//     padding: "8px 12px",
//     textAlign: "left",
//     fontSize: "13px",
//     fontWeight: "600",
//     color: "#555",
//     backgroundColor: "transparent",
//     borderBottom: "1px solid #ddd",
//     whiteSpace: "nowrap",
//   };

//   const tdBase = {
//     padding: "10px 12px",
//     fontSize: "13px",
//     color: "#333",
//   };

//   return (
//     // No border/radius on this wrapper — the section (Body-1-C424342) is the boundary
//     <div style={{ width: "100%", overflow: "hidden" }}>
//       <table style={{ width: "100%", borderCollapse: "collapse" }}>
//         <thead>
//           <tr>
//             <th style={{ ...thStyle, width: "40px" }}>
//               <div style={{ display: "flex", justifyContent: "center" }}>
//                 <CustomCheckbox checked={allSelected} onChange={handleHeaderCheck} />
//               </div>
//             </th>
//             {/* <th style={{ ...thStyle, width: "33%" }}>Plan Name</th> */}
//             <th style={{ ...thStyle, width: "30.5%" }}>Plan Name</th>
//             <th style={thStyle}>Description</th>
//           </tr>
//         </thead>
//         <tbody>
//           {coursePlans.length === 0 ? (
//             <tr>
//               <td colSpan={3} style={{ ...tdBase, textAlign: "center", color: "#999", padding: "20px" }}>
//                 No course plans available.
//               </td>
//             </tr>
//           ) : (
//             coursePlans.map((plan, idx) => {
//               const isChecked = selectedPlanIds.includes(plan.course_plan_id);
//               const isLast    = idx === coursePlans.length - 1;
//               // No border on last row so it doesn't clash with section's bottom boundary
//               const rowBorder = isLast ? "none" : "1px solid #eee";
//               return (
//                 <tr
//                   key={plan.course_plan_id}
//                   // style={{ backgroundColor: isChecked ? "#e8f0fe" : "transparent", cursor: "pointer" }}
//                   style={{ backgroundColor: "transparent", cursor: "pointer" }}
//                   onClick={() => handleRowCheck(plan.course_plan_id)}
//                 >
//                   <td style={{ ...tdBase, borderBottom: rowBorder }}>
//                     <div style={{ display: "flex", justifyContent: "center" }}>
//                       <CustomCheckbox checked={isChecked} onChange={() => handleRowCheck(plan.course_plan_id)} />
//                     </div>
//                   </td>
//                   <td style={{ ...tdBase, borderBottom: rowBorder }}>{plan.plan_name}</td>
//                   <td style={{ ...tdBase, borderBottom: rowBorder, color: "#666" }}>{plan.description || "—"}</td>
//                 </tr>
//               );
//             })
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default CoursePlanTable;



















import React from "react";

const CustomCheckbox = ({ checked, onChange }) => (
  <div
    onClick={(e) => { e.stopPropagation(); onChange(); }}
    style={{
      width: "16px",
      height: "16px",
      borderRadius: "3px",
      border: "1.5px solid var(--DppInputBorder, #d0d0d0)",
      backgroundColor: "var(--DppInputBackground, #fff)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0,
    }}
  >
    {checked && (
      <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
        <path d="M1 3.5L3.8 6.5L9 1" stroke="var(--Gray-2, #6A6A6A)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )}
  </div>
);

const CoursePlanTable = ({ coursePlans = [], selectedPlanIds = [], setSelectedPlanIds }) => {
  const allSelected =
    coursePlans.length > 0 && coursePlans.every((p) => selectedPlanIds.includes(p.course_plan_id));

  const handleHeaderCheck = () => {
    if (allSelected) setSelectedPlanIds([]);
    else setSelectedPlanIds(coursePlans.map((p) => p.course_plan_id));
  };

  const handleRowCheck = (id) => {
    setSelectedPlanIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const thStyle = {
    padding: "8px 12px",
    textAlign: "left",
    fontSize: "14px",
    fontWeight: "600",
    color: "var(--Gray-2, #6A6A6A)",
    backgroundColor: "transparent",
    borderBottom: "1px solid var(--DppInputBorder, #d0d0d0)",
    whiteSpace: "nowrap",
  };

  const tdBase = {
    padding: "10px 12px",
    fontSize: "14px",
    color: "var(--Gray-2, #6A6A6A)",
  };

  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ ...thStyle, width: "40px" }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <CustomCheckbox checked={allSelected} onChange={handleHeaderCheck} />
              </div>
            </th>
            <th style={{ ...thStyle, width: "30.5%" }}>Plan Name</th>
            <th style={thStyle}>Description</th>
          </tr>
        </thead>
        <tbody>
          {coursePlans.length === 0 ? (
            <tr>
              <td colSpan={3} style={{ ...tdBase, textAlign: "center", color: "var(--Gray-2, #6A6A6A)", padding: "20px" }}>
                No course plans available.
              </td>
            </tr>
          ) : (
            coursePlans.map((plan, idx) => {
              const isChecked = selectedPlanIds.includes(plan.course_plan_id);
              const isLast    = idx === coursePlans.length - 1;
              const rowBorder = isLast ? "none" : `1px solid var(--DppSectionBorder, #eeeeee)`;
              return (
                <tr
                  key={plan.course_plan_id}
                  style={{ backgroundColor: "transparent", cursor: "pointer" }}
                  onClick={() => handleRowCheck(plan.course_plan_id)}
                >
                  <td style={{ ...tdBase, borderBottom: rowBorder }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <CustomCheckbox checked={isChecked} onChange={() => handleRowCheck(plan.course_plan_id)} />
                    </div>
                  </td>
                  <td style={{ ...tdBase, borderBottom: rowBorder }}>{plan.plan_name}</td>
                  <td style={{ ...tdBase, borderBottom: rowBorder }}>{plan.description || "—"}</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CoursePlanTable;